import { useState, useEffect } from 'react';
import { Box, Button, Chip, Tabs, Tab } from '@mui/material';
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
    fetchStudents,
    fetchInstructors,
    fetchAssistants,
    blockUserThunk,
    unBlockUserThunk,
} from './Slices/usersSlice';
import BreadCrumb from '../../../common/components/Breadcrumb';
import { usersBread } from '../../../utils/StaticData/Breadcrumbs/createCourse';
import { getColumns } from './tableColumns';

const Users = () => {
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();
    const { students, instructors, assistants, loading } = useSelector(
        (state) => state.users,
    );

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (value === 0) {
            dispatch(fetchStudents());
        } else if (value === 1) {
            dispatch(fetchInstructors());
        } else {
            dispatch(fetchAssistants());
        }
    }, [value, dispatch]);

    const handleToggleBlock = async (id, isBlocked) => {
        const action = isBlocked ? unBlockUserThunk : blockUserThunk;
        const resultAction = await dispatch(action(id));
        if (action.fulfilled.match(resultAction)) {
            toast.success(
                `User has been ${isBlocked ? 'unblocked' : 'blocked'}`,
            );
            if (value === 0) {
                dispatch(fetchStudents());
            } else if (value === 1) {
                dispatch(fetchInstructors());
            } else {
                dispatch(fetchAssistants());
            }
        } else {
            toast.error(resultAction.payload || 'Failed to update user status');
        }
    };

    const data =
        value === 0 ? students : value === 1 ? instructors : assistants;
    const columns = getColumns(handleToggleBlock);

    return (
        <Box px={{ xs: 4.5, md: 9 }} className="bread-button-container">
            <Box
                display="flex"
                justifyContent="space-between"
                flexDirection={{ xs: 'column' }}
            >
                <BreadCrumb breadItems={usersBread} />
                <Box
                    className="button-container"
                    display="flex"
                    flexDirection={{ xs: 'row-reverse', md: 'column' }}
                    justifyContent={{ xs: 'space-between' }}
                    alignItems="end"
                >
                    <Box>
                        <Link to="/dashboard/users/add-users">
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                            >
                                Add Users
                            </Button>
                        </Link>
                    </Box>
                </Box>
            </Box>

            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="users-tabs"
                textColor="secondary"
                indicatorColor="secondary"
            >
                <Tab label="STUDENTS" id="0" aria-controls="users-tab-0" />
                <Tab label="INSTRUCTORS" id="1" aria-controls="users-tab-1" />
            </Tabs>
            <Box height={400} width="100%" mt={1}>
                <DataGrid
                    rows={data}
                    columns={columns}
                    getRowId={(row) => row?._id}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    disableRowSelectionOnClick
                    isRowSelectable={() => false}
                    loading={loading}
                    sx={{
                        // Remove cell focus outline (the blue border on clicked cell)
                        '& .MuiDataGrid-cell:focus': {
                            outline: 'none',
                        },
                        '& .MuiDataGrid-cell:focus-within': {
                            outline: 'none',
                        },
                        // Remove selected row highlight
                        '& .MuiDataGrid-row.Mui-selected': {
                            backgroundColor: 'transparent',
                        },
                        '& .MuiDataGrid-row.Mui-selected:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default Users;
